import { isPlatformServer, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { Response } from 'express';
import { METADATA_SERVICE, MetadataService } from 'src/app/common/metadata/metadata.service';
import { RouteTranslatePipe } from 'src/app/_shared/pipes/route-translate.pipe';
import { RESPONSE } from 'src/express.tokens';
import { FooterComponent } from '../../_shared/components/footer/footer.component';
import { HeaderComponent } from '../../_shared/components/header/header.component';

@Component({
  selector: 'sharry-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [I18NextModule, MatButtonModule, RouterLink, RouteTranslatePipe, HeaderComponent, FooterComponent],
})
export class NotFoundComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: NonNullable<unknown>,
    @Optional() @Inject(RESPONSE) private response: Response,
    @Inject(METADATA_SERVICE) private metadataService: MetadataService,
    private location: Location,
  ) {}

  ngOnInit() {
    this.metadataService.setMetadataPage('not-found', this.location.path());
    if (isPlatformServer(this.platformId) && this.response) {
      this.response.status(404);
    }
  }
}
